import React from 'react';

const addedClasses =
  'rounded bg-green-100 px-1 py-0.5 text-green-800 dark:bg-green-900/30 dark:text-green-400';
const removedClasses =
  'rounded bg-red-100 px-1 py-0.5 text-red-800 line-through dark:bg-red-900/30 dark:text-red-400';

export function DiffComparison(
  current?: string | number | null,
  previous?: string | number | null,
  isFirst?: boolean,
): React.ReactNode {
  const curr =
    current === null || current === undefined ? '' : String(current).trim();
  const prev =
    previous === null || previous === undefined ? '' : String(previous).trim();

  // No change
  if (prev === curr) {
    return curr ? <>{current}</> : null;
  }

  // Added (previous was empty, now has value)
  if (!prev && curr && !isFirst) {
    return <span className={addedClasses}>{current}</span>;
  }

  // Removed (current is empty, previous had value)
  if (!curr && prev) {
    return <span className={removedClasses}>{previous}</span>;
  }

  if (!prev || !curr) {
    return curr ? <>{current}</> : null;
  }

  // Modified — old value in red strikethrough, new value in green
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <span className={removedClasses}>{previous}</span>
      <span className={addedClasses}>{current}</span>
    </span>
  );
}
